import Home from '../views/Home.vue'
import Articles from '../views/Articles.vue'
import Article from '../views/Article.vue'
import AboutUs from '../views/AboutUs.vue'
import RealTimePrice from '../views/RealTimePrice.vue'
import Tutorial from '../views/Tutorial.vue'
import FAQ from '../views/FAQ.vue'
import Rules from '../views/Rules.vue'
import FastBuy from '../views/FastBuy.vue'
import Checkout from '../views/Checkout.vue'

import LoginByNumber from '../views/auth/LoginByNumber.vue'
import LoginByPassword from '../views/auth/LoginByPassword.vue'
import LoginByEmail from '../views/auth/LoginByEmail.vue'
import Register from '../views/auth/Register.vue'
import VerifyCode from '../views/auth/VerifyCode.vue'
import EmailVerifyCode from '../views/auth/EmailVerifyCode.vue'
import SetPassword from '../views/auth/SetPassword.vue'
import Authentication from '../views/profile/Authentication.vue'
import Profile from '../views/profile/Profile.vue'
import Security from '../views/profile/Security.vue'

import MyAccount from '../views/profile/MyAccount.vue'
import Exchanges from '../views/profile/Exchanges.vue'
import Dashboard from '../views/profile/Dashboard.vue'
import Notifications from '../views/profile/Notifications.vue'
import Referral from '../views/profile/Referral.vue'

import BankAccounts from '../views/profile/BankAccounts.vue'
import Wallets from '../views/profile/Wallets.vue'

import Records from '../views/profile/Records.vue'
import ConvertCrypto from '../views/profile/ConvertCrypto.vue'
import Transaction from '../views/profile/Transaction.vue'
import Deposit from '../views/profile/Deposit.vue'
import Withdraw from '../views/profile/Withdraw.vue'

import ExchangeDetails from '../views/profile/ExchangeDetails.vue'

import Tickets from '../views/profile/Tickets.vue'
import AddTicket from '../views/profile/AddTicket.vue'
import Ticket from '../views/profile/Ticket.vue'

import Market from '../views/profile/Market.vue'
import PaymentAdvanceInvoice from '../views/profile/PaymentAdvanceInvoice.vue'

const routes = [

    // Home and outside of dashboard
    { path: '/', name: 'Home', component: Home, meta: { authLevel: 1 } },
    { path: '/articles', name: 'Articles', component: Articles, meta: { authLevel: 1 } },
    { path: '/article/:slug', name: 'Article', component: Article, meta: { authLevel: 1 } },
    { path: '/about-us', name: 'AboutUs', component: AboutUs, meta: { authLevel: 1 } },
    { path: '/crypto-prices', name: 'RealTimePrice', component: RealTimePrice, meta: { authLevel: 1 } },
    { path: '/tutorial', name: 'Tutorial', component: Tutorial, meta: { authLevel: 1 } },
    { path: '/faq', name: 'FAQ', component: FAQ, meta: { authLevel: 1 } },
    { path: '/terms', name: 'Rules', component: Rules, meta: { authLevel: 1 } },
    { path: '/buy/fast', name: 'FastBuy', component: FastBuy, meta: { authLevel: 1 } },
    { path: '/checkout/electronic', name: 'Checkout', component: Checkout, meta: { authLevel: 1 } },

    // authentication
    { path: '/login', name: 'LoginByPassword', component: LoginByPassword, meta: { authLevel: 2 } },
    { path: '/forget-password', name: 'LoginByNumber', component: LoginByNumber, meta: { authLevel: 2 } },
    { path: '/email/login', name: 'LoginByEmail', component: LoginByEmail, meta: { authLevel: 2 } },
    { path: '/register', name: 'Register', component: Register, meta: { authLevel: 2 } },
    { path: '/verify-code', name: 'VerifyCode', component: VerifyCode, meta: { authLevel: 2 } },
    { path: '/email/verify-code', name: 'EmailVerifyCode', component: EmailVerifyCode, meta: { authLevel: 2 } },

    { path: '/authentication', name: 'Authentication', component: Authentication, meta: { authLevel: 3 } },

    { path: '/set-password', name: 'SetPassword', component: SetPassword, meta: { authLevel: 4 } },
    { path: '/profile', name: 'Profile', component: Profile, meta: { authLevel: 5 } },
    { path: '/security', name: 'Security', component: Security, meta: { authLevel: 5 } },

    // dashboard
    { path: '/my-account', name: 'MyAccount', component: MyAccount, meta: { authLevel: 4 } },
    { path: '/exchanges', name: 'Exchanges', component: Exchanges, meta: { authLevel: 4 } },
    { path: '/dashboard', name: 'Dashboard', component: Dashboard, meta: { authLevel: 4 } },
    { path: '/notifications', name: 'Notifications', component: Notifications, meta: { authLevel: 4 } },
    { path: '/referral', name: 'Referral', component: Referral, meta: { authLevel: 5 } },

    // bank accounts and wallet
    { path: '/accounts', name: 'BankAccounts', component: BankAccounts, meta: { authLevel: 5 } },
    { path: '/wallets', name: 'Wallets', component: Wallets, meta: { authLevel: 5 } },

    //tickets
    { path: '/tickets', name: 'Tickets', component: Tickets, meta: { authLevel: 4 } },
    { path: '/tickets/new', name: 'AddTicket', component: AddTicket, meta: { authLevel: 4 } },
    { path: '/ticket/:id', name: 'Ticket', component: Ticket, meta: { authLevel: 4 } },

    // exchanges
    { path: '/transaction/buy-sell', name: 'Transaction', component: Transaction, meta: { authLevel: 5 } },
    { path: '/transaction/convert/crypto', name: 'ConvertCrypto', component: ConvertCrypto, meta: { authLevel: 5 } },

    { path: '/transaction/history', name: 'Records', component: Records, meta: { authLevel: 5 } },
    { path: '/transaction/details/:id', name: 'ExchangeDetails', component: ExchangeDetails, meta: { authLevel: 5 } },

    { path: '/transaction/deposit', name: 'Deposit', component: Deposit, meta: { authLevel: 5 } },
    { path: '/transaction/withdraw', name: 'Withdraw', component: Withdraw, meta: { authLevel: 5 } },

    { path: '/market', name: 'Market', component: Market, meta: { authLevel: 5 } },

    { path: '/payment-advance-invoice', name: 'PaymentAdvanceInvoice', component: PaymentAdvanceInvoice, meta: { authLevel: 5 } },

]

import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes,
})

export default router
